/**
 * /home — the one Home URL for every role.
 *
 * - Platform ADMIN: Admin Home renders here, at /home (no separate URL).
 * - MEMBER / VIEWER: Home is the Inbox, so /home forwards to /inbox.
 *
 * `/admin-home` is kept only as a redirect to /home for old bookmarks.
 */
import { Navigate } from "react-router-dom";

import AdminHomePage from "@/features/admin-home/AdminHomePage";
import { useAuth } from "@/state/AuthContext";
import { isPlatformAdmin } from "@/utils/access";

export default function HomeRoute() {
  const { user, loading: authLoading } = useAuth();

  if (authLoading) {
    return (
      <div
        className="flex h-64 items-center justify-center"
        data-testid="home-route-hydrating"
      >
        <div className="text-sm text-slate-500">Loading…</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (isPlatformAdmin(user)) return <AdminHomePage />;

  return <Navigate to="/inbox" replace />;
}
